import store from 'store';
import { http } from 'http';
import NProgressApp from 'utils/nprogress';
import { AUTH_REQUEST } from 'store/actions/auth';

// Request interceptor
http.interceptors.request.use(
  config => {
    const loading = config.loading !== undefined ? config.loading : true;
    if (loading) {
      NProgressApp.start();
    }
    /* eslint no-param-reassign:
    ["error", { "props": true, "ignorePropertyModificationsFor": ["config"] }] */
    if (
      store.getters['auth/isAuthenticated'] &&
      config.headers['content-type'] !== 'application/x-www-form-urlencoded'
    ) {
      config.headers.Authorization = `${store.getters['auth/tokenType']} ${store.getters['auth/accessToken']}`;
    }
    return config;
  },
  error => Promise.reject(error.data)
);

// Response interceptor
http.interceptors.response.use(
  response => {
    const loading = response.config.loading !== undefined ? response.config.loading : true;
    if (loading) {
      NProgressApp.done();
    }
    return Promise.resolve(response);
  },
  error => {
    NProgressApp.done();
    const originalRequest = error.config;
    /* eslint no-underscore-dangle: ["error", { "allow": ["_retry"] }] */
    if (error.response.status === 401 && !originalRequest._retry) {
      // if the error is 401 and hasent already been retried
      originalRequest._retry = true; // now it can be retried
      return store
        .dispatch(`auth/${AUTH_REQUEST}`)
        .then(
          () => http(originalRequest) // retry the request that errored out
        )
        .catch(() => {
          for (let i = 0; i < error.response.data.errors.length; i += 1) {
            if (error.response.data.errors[i] === 'TOKEN-EXPIRED') {
              // Do something
              return;
            }
          }
        });
    }

    // Do something with response error
    return Promise.reject(error);
  }
);
